module.exports = __webpack_public_path__ + "static/media/13.e4c21017.jpg";